import { render, staticRenderFns } from "./CommitmentsSection.vue?vue&type=template&id=19b5772c"
import script from "./CommitmentsSection.vue?vue&type=script&lang=js"
export * from "./CommitmentsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports